import { createActionGroup, emptyProps } from '@ngrx/store';

export const NoActions = createActionGroup({
  source: 'No action',
  events: {
    'No action': emptyProps(),
  },
});
